export default __webpack_public_path__ + "static/media/problema-04.8cb01440.webp";